import { FiArrowRight } from "react-icons/fi";
import { Link } from "react-router-dom";
import "./Capabilities.css";

const capabilities = [
  {
    number: "01",
    title: "DTC Strategy & Growth",
    description: "End-to-end direct-to-consumer strategy — from market positioning to channel architecture. I build the blueprint that turns browsers into buyers and buyers into loyalists.",
  },
  {
    number: "02",
    title: "Shopify Plus Development",
    description: "Custom storefronts, headless builds, and platform migrations on Shopify Plus. Performance-obsessed, conversion-optimized, built to scale.",
  },
  {
    number: "03",
    title: "Conversion Design",
    description: "Data-informed design that moves the needle. Every pixel earns its place through A/B testing, heatmaps, and relentless iteration on what actually drives revenue.",
  },
  {
    number: "04",
    title: "Email & Retention",
    description: "Lifecycle marketing that keeps customers coming back. Klaviyo flows, segmentation strategy, and campaigns that feel personal — not automated.",
  },
  {
    number: "05",
    title: "Cannabis Compliance",
    description: "Navigating age-gating, payment processing, PACT Act compliance, and state-level regulations. I keep your revenue flowing in a shifting legal landscape.",
  },
  {
    number: "06",
    title: "Brand Identity",
    description: "From naming to visual systems — brand strategy and design that creates recognition, trust, and the kind of loyalty that can't be bought with ad spend.",
  },
];

const process = [
  { step: "01", title: "Discovery", description: "Deep dive into your business, market, and goals" },
  { step: "02", title: "Strategy", description: "Roadmap built on data, not assumptions" },
  { step: "03", title: "Build", description: "Execution with craft and precision" },
  { step: "04", title: "Optimize", description: "Continuous iteration driven by real results" },
];

function Capabilities() {
  return (
    <main className="cap">
      <div className="cap__grain" />

      <section className="cap__hero">
        <div className="cap__hero-label">Capabilities</div>
        <h1 className="cap__hero-title">
          What I<br />bring to it
        </h1>
        <p className="cap__hero-sub">
          Ten years of building, breaking, and refining what works in DTC ecommerce.
        </p>
      </section>

      <section className="cap__list">
        {capabilities.map((cap, i) => (
          <div
            className="cap__item"
            key={cap.number}
            style={{ animationDelay: `${0.2 + i * 0.07}s` }}
          >
            <div className="cap__item-left">
              <span className="cap__item-number">{cap.number}</span>
              <h2 className="cap__item-title">{cap.title}</h2>
            </div>
            <p className="cap__item-desc">{cap.description}</p>
          </div>
        ))}
      </section>

      <section className="cap__process">
        <div className="cap__process-header">
          <div className="cap__process-label">How I work</div>
          <h2 className="cap__process-title">
            From first call<br />to full scale
          </h2>
        </div>
        <div className="cap__process-grid">
          {process.map((step, i) => (
            <div
              className="cap__step"
              key={step.step}
              style={{ animationDelay: `${0.4 + i * 0.1}s` }}
            >
              <div className="cap__step-number">{step.step}</div>
              <h3 className="cap__step-title">{step.title}</h3>
              <p className="cap__step-desc">{step.description}</p>
              {i < process.length - 1 && (
                <div className="cap__step-arrow">
                  <FiArrowRight />
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      <section className="cap__cta">
        <div className="cap__cta-inner">
          <h2 className="cap__cta-title">Ready to move?</h2>
          <p className="cap__cta-sub">
            I partner with brands that are serious about growth. If that&rsquo;s you, let&rsquo;s talk.
          </p>
          <div className="cap__cta-actions">
            <Link to="/work" className="cap__cta-btn cap__cta-btn--primary">
              See the work <FiArrowRight />
            </Link>
            <Link to="/contact" className="cap__cta-btn cap__cta-btn--outline">
              Get in touch
            </Link>
          </div>
        </div>
      </section>

      <footer className="cap__footer">
        <div className="cap__footer-line" />
      </footer>
    </main>
  );
}

export default Capabilities;
